import React from 'react'
import { Button, FormGroup, Input, Select } from '../../../components/ui'
import { DEPARTMENT_TYPE_OPTIONS } from '../../../config/departmentTypes'

function DepartmentCreateForm({ formData, onChange, onSubmit, onCancel }) {
  return (
    <div className="departments-create-card ds-card">
      <form onSubmit={onSubmit} className="department-form departments-create-form">
        <h2>Создание подразделения</h2>
        <FormGroup label="Название подразделения:" required>
          <Input
            type="text"
            value={formData.name}
            onChange={(event) => onChange({ ...formData, name: event.target.value })}
            required
            autoFocus
          />
        </FormGroup>
        <FormGroup label="Тип подразделения:" required>
          <Select
            value={formData.department_type}
            onChange={(event) => onChange({ ...formData, department_type: event.target.value })}
          >
            {DEPARTMENT_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </Select>
        </FormGroup>
        <div className="form-actions">
          <div className="button-group">
            <Button type="button" variant="secondary" onClick={onCancel}>
              Отмена
            </Button>
            <Button type="submit" variant="primary">
              + Создать
            </Button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default DepartmentCreateForm
